import { Spin } from "antd";
import React from "react";
import styled from "styled-components";

const WrapFullScreen = styled.div`
  width: 100vw;
  height: 100vh;
  text-align: center;
  background: rgba(0, 0, 0, 0.1);
  .ant-spin {
    margin-top: 50vh;
  }
`;

const Loading = () => {
  return (
    <WrapFullScreen>
      <Spin />
    </WrapFullScreen>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading/index.tsx